import PropTypes from 'prop-types';

export default PropTypes.shape({
  columnsWrapper: PropTypes.string,
  adColumn: PropTypes.string,
  contentColumn: PropTypes.string,
  contentItems: PropTypes.string,
  ad: PropTypes.string,
});
